import { createSelector } from 'reselect';

import { selectDataSubjects } from '@main/privacy-center/src/containers/ActiveDataSubject/selectors';
import { selectIsLoggedIn } from '@main/privacy-center/src/containers/App/selectors';

import { TakeControlState } from './slice';

/**
 * The selector for the `TakeControl` state store slice
 */
export const getTakeControlSlice = (state: any): TakeControlState =>
  state.TakeControl;

export const selectDisabledActions = createSelector(
  getTakeControlSlice,
  ({ disabledActions }) => disabledActions,
);

/**
 * The take control modal name when clicking the take control button
 */
export const selectTakeControlModalName = createSelector(
  selectIsLoggedIn,
  selectDataSubjects,
  (isLoggedIn, dataSubjects) =>
    isLoggedIn || dataSubjects.length === 1 ? 'take-control' : 'select-subject',
);
